import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Card, Row, Space, Typography } from 'antd';
import { DeleteOutlined, CopyOutlined } from "@ant-design/icons";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {FileCopyRounded, DeleteForeverRounded, LocalActivityRounded} from "@mui/icons-material";
import { removeResponseById } from '../../Store/slices/gpt.slice';
import TimeCell from "../../Components/TimeCell";

const stripHtmlTags = (html) => {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
};





const ResponseMessage = ({ response, timestamp, extra, cardClass='', maxHeight=400 }) => {
    const dispatch = useDispatch();
    const [content, setContent] = useState('');
    useEffect(() => {
        setContent(<div dangerouslySetInnerHTML={{__html: response.data}}></div>);
    }, [response]); // Dependence on `response` to ensure effect runs only if `response` changes

    const handleRemoveClick = () => {
        dispatch(removeResponseById(response.id)); // Use UUID to remove response
    };

    const handleCopyClick = () => {
        const plainText = stripHtmlTags(response.data); // Strip HTML tags from response data
        navigator.clipboard.writeText(plainText)
          .then(() => {
            console.log('Response copied to clipboard');
          })
          .catch((error) => {
            console.error('Failed to copy response: ', error);
          });
    };


    return (
        <Card
            className={cardClass}
            style={{borderRadius: '16px', maxHeight}}
            bordered={false}
            title={
            <Row justify={'space-between'}>
                <Space >
                    <TimeCell timestamp={timestamp} />
                    <ButtonGroup size={'small'}>
                        <Button
                            variant={'text'}
                            startIcon={<DeleteForeverRounded />}
                            onClick={handleRemoveClick}

                        />
                        <Button
                            variant={'text'}
                            startIcon={<FileCopyRounded />}
                            onClick={handleCopyClick}
                        />
                    </ButtonGroup>
                    {extra}
                </Space >
                {response.srcLocation&&(
                    <Space>
                        <Typography.Text style={{fontSize: 13, color: "#0033ff", fontWeight: '600'}}>
                            {response.srcLocation}
                        </Typography.Text>
                    </Space>
                )}
            </Row>

            }
        >
            <div style={{fontFamily:"var(--mono-font)", maxHeight: maxHeight*0.8, overflowY: 'scroll'}}>
                {content}
            </div>
        </Card>
    );
};

export default ResponseMessage;
